import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useCallback } from 'react';
import { z } from 'zod';
import { usePaginationSearch } from '@/lib/listPage';
import { AllDealTable } from '@/routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/-components/AllDealTable';
import { AllSearchFilterBar } from '@/routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/-components/AllSearchFilterBar';
import { useAllDealList } from '@/routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/-query';
const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional()
});
export const Route = createFileRoute('/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/')({
  component: AllTab,
  validateSearch: zodValidator(SearchSchema)
});
function AllTab() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const [pagination, setPagination] = usePaginationSearch({
    search,
    onSearchChange: s => navigate({
      search: s
    })
  });
  const {
    data,
    isPending
  } = useAllDealList({
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    freeText: search.freeText
  });
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    navigate({
      search: prev => ({
        ...prev,
        freeText: e.target.value || undefined,
        pageIndex: 0
      })
    });
  }, [navigate]);
  return <>
      <AllSearchFilterBar searchValue={search.freeText ?? ''} onSearchChange={handleSearchChange} />
      <AllDealTable data={data?.items ?? []} isPending={isPending} totalCount={data?.count} pageCount={data?.maxPage} pagination={pagination} onPaginationChange={setPagination} hideDeviceColumn className="flex-1 min-h-0" />
    </>;
}